// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const mooringBollard = defineModel({
  id: "mooring-bollard",
  batchId: "future",
  name: "Mooring bollard",
  tags: ["scenery","mooring","bollard","low-poly","age-of-mcp","future","water"],
  summary: "A quayside bollard for tying up boats while loading.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.25,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.12, 0.14, 0.34, 10), color: "#4a4540", position: [0, 0.17, 0] },
      { geometry: new THREE.SphereGeometry(0.16, 10, 6, 0, 6.283185, 0, 1.570796), color: "#5a554f", position: [0, 0.34, 0], scale: [1, 0.6, 1] },
      { geometry: new THREE.TorusGeometry(0.16, 0.025, 5, 12), color: "#b9a574", position: [0, 0.187, 0], rotation: [1.570796, 0, 0], scale: [1, 1.1, 1] },
      { geometry: new THREE.CylinderGeometry(0.17, 0.18, 0.04, 10), color: "#3c3a36", position: [0, 0.02, 0] },
    ],
  animations: [],
});
